export default "__VITE_ASSET__DUCOwf8C__"